import { createSelector } from '@ngrx/store';

const selectHubspot = (state: any) => {
  return state.hubspot;
};
export const selectSearchStateHubspotChanges = createSelector(
  selectHubspot,
  (state) => state.report.hubspot_changes
);

export const selectHubspotContactSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotContactFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotNewContactSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotNewContactFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotCompanySuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotCompanyFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotCompaniesSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotCompaniesFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotCompanyLifeCycleStagesSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotCompanyLifeCycleStagesFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotCompanyIndustriesSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotCompanyIndustriesFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotDealOwnersSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotDealOwnersFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotDealPipelinesSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotDealPipelinesFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotDealStagesSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotDealStagesFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotDealsSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotDealsFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectShowMoreHubspotDealsSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectShowMoreHubspotDealsFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotNewDealSuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotNewDealFailure = createSelector(
  selectHubspot,
  (state) => state.error
);

export const selectHubspotNewCompanySuccess = createSelector(
  selectHubspot,
  (state) => state
);

export const selectHubspotNewCompanyFailure = createSelector(
  selectHubspot,
  (state) => state.error
);
